import { Route, Routes } from 'react-router-dom';
import { AppContainer } from './AppContainer';
import { DirectOTPAuth } from './DirectOTPAuth';
import { accessToken, refreshToken } from '../utils/auth';

interface DirectOTPContainerProps {
    onSuccess?: (tokens: any) => void;
}

export const DirectOTPContainer = ({ onSuccess }: DirectOTPContainerProps) => {
    const setTokens = async (tokens: any) => {
        try {
            // Store tokens in localStorage (same as PhoneAuth)
            refreshToken.set(tokens.refresh);
            accessToken.set(tokens.access);

            // Call parent's onSuccess callback
            onSuccess?.(tokens);
        } catch (error) {
            console.error('Error storing tokens:', error);
        }
    };

    return (
        <Routes>
            <Route path="/" element={<AppContainer />}>
                <Route path="/" element={<DirectOTPAuth setTokens={setTokens} />} />
            </Route>
        </Routes>
    );
};
